import React, { useEffect, useState } from "react";
import ReusableButton from "./ReusableButton";
import Cards from "./imageFiles/Cards.png";
import { Doughnut } from "react-chartjs-2";
import { Skeleton } from "@mui/material";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import "./TheStudentDashboard.css";
import CreditCoin from './imageFiles/CreditCoin.png';
import { history } from "../../../../../../helper/history";
import { routes } from "../../../../../../helper/routes";

const CreditsUsage = ({ userCredits = { total_credits: 0, used_credits: 0, available_credits: 0 }, student_dashboard_initial_loading }) => {

  const [totalData, setTotalData] = useState(null);
  const [usedData, setUsedData] = useState(null);
  const [availableData, setAvailableData] = useState(null);

  
  const doughnutOptions = {
    rotation: 0,
    circumference: 360,
    cutout: "75%",
    plugins: {
      legend: { display: false },
    },
  };

  useEffect(() => {
    
    const total = userCredits?.total_credits || 0;
    const used = userCredits?.used_credits || 0;
    const available = userCredits?.available_credits || 0;

    setTotalData({
      datasets: [
        {
          data: [total, 0],
          backgroundColor: ["#00C3E1", "#F5F5F5"],
          borderWidth: 0,
          borderRadius: 10,
          cutout: "75%",
        },
      ],
    });

    setUsedData({
      datasets: [
        {
          data: [used, Math.max(total - used, 0)],
          backgroundColor: ["#F5B300", "#FCEFD4"],
          borderWidth: 0,
          borderRadius: 10,
          cutout: "75%",
        },
      ],
    });

    setAvailableData({
      datasets: [
        {
          data: [available, Math.max(total - available, 0)],
          backgroundColor: ["#2C9C81", "#D3E8DF"],
          borderWidth: 0,
          borderRadius: 10,
          cutout: "75%",
        },
      ],
    });
  }, [userCredits]);

  const handleBuyCredit = async()=>{

    history.push(routes.assess_subscriptions)

  }

  return (
    <div className="credits-chart-content">
      <div className="credits-usage-box">
        <div className="credits-header">
          <h6 className="credits-title">Credits</h6>
          <img src={CreditCoin} className="credits-icon" />
        </div>
        <div className="credits-chart-content">
          {student_dashboard_initial_loading ? (
            <div className="credits-loading">
              {[...Array(3)].map((_, idx) => (
                <Skeleton key={idx} variant="circular" width={80} height={80} />
              ))}
            </div>
          ) : userCredits?.total_credits <= 0 ? (
            <div className="no-credits-section">
              <div>
                <p>No Credits available</p>
                <ReusableButton label="Buy Credits" onClick={() => handleBuyCredit()} />
              </div>
              <img src={Cards} alt="Card" width="80" />
            </div>
          ) : (
            <div className="credits-chart-row">
              <div className="chart-item">
                <div className="doughnut-wrapper">
                  {totalData && <Doughnut data={totalData} options={doughnutOptions} />}
                  <div className="doughnut-center-label">Total {userCredits?.total_credits || 0}</div>
                </div>
              </div>

              <div className="chart-item">
                <div className="doughnut-wrapper">
                  {usedData && <Doughnut data={usedData} options={doughnutOptions} />}
                  <div className="doughnut-center-label">Used {userCredits?.used_credits || 0}</div>
                </div>
              </div>

              <div className="chart-item">
                <div className="doughnut-wrapper-3">
                  {availableData && <Doughnut data={availableData} options={doughnutOptions} />}
                  <div className="doughnut-center-label">Available {userCredits?.available_credits || 0}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreditsUsage;
